// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c12f7c88]:export{primaryColor:#6699ba;secondaryColor:#6699ba;accentColor:#c41230}", ""]);
// Exports
module.exports = exports;
